export default "/assets/04024ef29ae44aa7.svg"